export const USER_ROLES = [
  { value: 'admin', label: 'Administrador' },
  { value: 'manager', label: 'Gestor' },
  { value: 'employee', label: 'Funcionário' },
  { value: 'outsourced', label: 'Terceirizado' },
  { value: 'customer', label: 'Cliente' },
  { value: 'guest', label: 'Convidado' },
] as const;

export const USER_STATUS = [
  { value: 'active', label: 'Ativo' },
  { value: 'inactive', label: 'Inativo' },
  { value: 'pending', label: 'Pendente' },
  { value: 'suspended', label: 'Suspenso' },
  { value: 'blocked', label: 'Bloqueado' },
] as const;

export const GENDER_OPTIONS = [
  { value: 'MALE', label: 'Masculino' },
  { value: 'FEMALE', label: 'Feminino' },
  { value: 'OTHER', label: 'Outro' },
] as const;

export const UNIT_OPTIONS = [
  { value: '101', label: 'Unidade 101' },
  { value: '102', label: 'Unidade 102' },
  { value: '201', label: 'Unidade 201' },
  { value: '202', label: 'Unidade 202' },
] as const;

export const SECTION_OPTIONS = [
  { value: 'A', label: 'Seção A' },
  { value: 'B', label: 'Seção B' },
  { value: 'C', label: 'Seção C' },
] as const;


export const initialValues = {
  name: '',
  email: '',
  documentNumber: '',
  status: 'active',
  role: 'customer',
  birth_date: '',
  gender_flag: '', 
  phoneNumber: '',
  cnh_number: '',
  cnh_expiration_date: '',
  unit: '',
  section_name: '',
  description: '',
  password: '',
  confirmPassword: '',
  imageUrl: '',
  avatarFile: null,
  tenantId: '',
  tenantName: '',
};